videojs.addLanguage('ru', {
	"Error loading media: File could not be played": "Ошибка загрузки видео: Файл не может быть проигран",
	"Too many errors. Last error: ": "Слишком много ошибок. Последняя ошибка: ",
	"networkError": "ошибка сети",
	"no level found in manifest": "фрагменты видео не найдены в манифесте. Обратитесь в техподдержку"
});